
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nemovitost/[id]",
      function () {
        return require("private-next-pages/nemovitost/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nemovitost/[id]"])
      });
    }
  